"use client";

/**
 * 掛在 root layout（一次、全站共用）：把 401 的導回登入接到 next/navigation 的
 * router.replace，而非 window.location（避免整頁重載，也符合
 * @next/next/no-location-assign-relative-destination 規則）。本身不繪製任何東西。
 */
import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { configureApiClient } from "../lib/apiClient";
import { markSessionExpired } from "../lib/sessionExpiry";

export function ApiClientBootstrap() {
  const router = useRouter();

  useEffect(() => {
    configureApiClient({
      onUnauthorized: () => {
        // 先留下旗標再導頁：導頁會把 (dashboard) 子樹連同 ToastProvider 一起卸載，
        // 任何在此之後才顯示的 toast 都撐不到使用者看見（見 lib/sessionExpiry.ts）。
        // 訊息責任交給登入頁，讓「導頁」與「說明原因」變成同一條路徑。
        markSessionExpired();
        router.replace("/login");
      },
    });
  }, [router]);

  return null;
}
